import makeStyles from '@mui/styles/makeStyles';
import { BREAKPOINTS, COLORS, FONT_12 } from 'constants/styles';

export default makeStyles(
  {
    root: {
      marginTop: 80,
      marginBottom: 24,

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        marginTop: 20,
      }
    },
    copyright: {
      display: 'flex',
      backgroundColor: '#F7F7F9',
      borderRadius: 8,
      padding: 14,
      alignItems: 'center',
    },
    copyrightLabel: {
      ...FONT_12,
      color: COLORS.textGray,
    },
    titleLabel: {
      fontSize: 12,
      color: COLORS.textGray,
      marginRight: 8,
    },
    followUs: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
    },
  },
  { name: 'Footer' },
);
